import { createContext, useContext } from 'react'

import type { ExplorerReportScope } from '../types/explorer.types'

/**
 * The asset the open report is narrowed to (MYD-598), for components deep in
 * the filter UI.
 *
 * Only the facet picker needs it, four components below the screen, and
 * threading a prop through each layer for one consumer would make every one of
 * them carry something it never reads. Null when the report is unscoped, which
 * is also the default outside Explorer.
 */
export const ExplorerScopeContext = createContext<ExplorerReportScope | null>(null)

export const useExplorerScope = (): ExplorerReportScope | null => useContext(ExplorerScopeContext)
